export class ReportViewService {
    constructor(ApiService) {
        'ngInject';

        this.apiService = ApiService;
    }

    getReportDetailsObject({data}) {
        return this._getProgressReportDetailsdata(data);
    }

    /**********************************Private Methods************************* */


    _getProgressReportDetailsdata(details) {
		return {
			id: details.content_id,
			title : details.title,
			name: details.mask_name,
			selectedProgramYearId: details.fiscal_year_id,
			from: details.start_from,
			to: details.end_to,
			selectedServiceAreaId: details.service_area_id,
			serviceAreaName: details.name,
			image: this.apiService.getImageUrl(details.image),
			uuid: details.pdf,
			url: this.apiService.getResourceUrl(`files/pdf/${details.pdf}`),
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/report-view/report-view.service.js